// Event type interfaces
export interface EventTypeInfo {
  name: string;
  categories: string[];
}

// All available event types with their associated categories
export const EVENT_TYPES: EventTypeInfo[] = [
  // Art & Exhibitions types
  { name: 'Exhibitions & Galleries', categories: ['Art & Exhibitions'] },
  { name: 'Interactive & Digital', categories: ['Art & Exhibitions'] },
  { name: 'Street Art', categories: ['Art & Exhibitions'] },
  { name: 'Art Markets', categories: ['Art & Exhibitions'] },
  { name: 'Creative Workshops', categories: ['Art & Exhibitions'] },

  // Sport & Outdoor types
  { name: 'Professional Sports', categories: ['Sport & Outdoor'] },
  { name: 'Casual  Sports', categories: ['Sport & Outdoor'] },
  { name: 'Group Exercise', categories: ['Sport & Outdoor'] },
  { name: 'City Tours & Nature', categories: ['Sport & Outdoor'] },
  { name: 'Yoga & Pilates', categories: ['Sport & Outdoor'] },

  // Party types
  { name: 'Clubbing', categories: ['Party'] },
  { name: 'Underground', categories: ['Party'] },
  { name: 'House Parties', categories: ['Party'] },
  { name: 'festivals', categories: ['Party'] },

  // Activism types
  { name: 'Sustainability', categories: ['Activism'] },
  { name: 'Social Justice', categories: ['Activism'] },
  { name: 'Political', categories: ['Activism'] },
  { name: 'Community', categories: ['Activism'] },

  // Live Show & Music types
  { name: 'Concerts & Gigs', categories: ['Live Show & Music'] },
  { name: 'Open Mic & Jam', categories: ['Live Show & Music'] },
  { name: 'Stand-up Comedy', categories: ['Live Show & Music'] },
  { name: 'Theatre', categories: ['Live Show & Music'] },

  // Food & Drink types
  { name: 'Wine, Beer & More', categories: ['Food & Drink'] },
  { name: 'Pop-up Restaurants', categories: ['Food & Drink'] },
  { name: 'Food Markets', categories: ['Food & Drink'] },
  { name: 'Cooking Classes', categories: ['Food & Drink'] },
  { name: 'Special Nights & Menus', categories: ['Food & Drink'] },

  // Social Meetups types
  { name: 'Dating', categories: ['Social Meetups'] },
  { name: 'Hobbies', categories: ['Social Meetups'] },
  { name: 'Language Exchanges', categories: ['Social Meetups'] },
  { name: 'Networking Events', categories: ['Social Meetups'] },
  { name: 'Casual Hangouts', categories: ['Social Meetups'] },

  // Markets & Pop-Ups types
  { name: 'Flea Markets', categories: ['Markets & Pop-Ups'] },
  { name: 'Fashion & Vintage', categories: ['Markets & Pop-Ups'] },
  { name: 'Handmade & Crafts', categories: ['Markets & Pop-Ups'] },
  { name: 'Pop-up Market', categories: ['Markets & Pop-Ups'] },
  { name: 'Food Markets', categories: ['Markets & Pop-Ups'] },

  // Skills & Learning types
  { name: 'Technology', categories: ['Skills & Learning'] },
  { name: 'Creative Workshops', categories: ['Skills & Learning'] },
  { name: 'Business & Finance', categories: ['Skills & Learning'] },
  { name: 'Self-Development', categories: ['Skills & Learning'] },
  { name: 'Cooking Classes', categories: ['Skills & Learning'] },

  // Family types
  { name: 'Kids Activities', categories: ['Family'] },
  { name: 'Family-Friendly Festivals', categories: ['Family'] },
  { name: 'Educational Workshops', categories: ['Family'] },
  { name: 'Community Gatherings', categories: ['Family'] },
  { name: 'Child Theater Play', categories: ['Family'] },

  // Spiritual & Wellness types
  { name: 'Meditation & Mindfulness', categories: ['Spiritual & Wellness'] },
  { name: 'Alternative Therapies', categories: ['Spiritual & Wellness'] },
  { name: 'Yoga & Pilates', categories: ['Spiritual & Wellness'] },
  { name: 'Wellness & Nutrition', categories: ['Spiritual & Wellness'] },
  { name: 'Religion', categories: ['Spiritual & Wellness'] },

  // Movie & Theatre types
  { name: 'Movie Screenings', categories: ['Movie & Theatre'] },
  { name: 'Theatre', categories: ['Movie & Theatre'] },
  { name: 'Stand-up Comedy', categories: ['Movie & Theatre'] },
  { name: 'Child Theater Play', categories: ['Movie & Theatre'] }
];

// All available categories
export const EVENT_CATEGORIES = [
  'Art & Exhibitions',
  'Sport & Outdoor',
  'Party',
  'Activism',
  'Live Show & Music',
  'Food & Drink',
  'Social Meetups',
  'Markets & Pop-Ups',
  'Skills & Learning',
  'Family',
  'Spiritual & Wellness',
  'Movie & Theatre'
] as const;

// Type definitions
export type EventCategory = typeof EVENT_CATEGORIES[number];
export type EventType = EventTypeInfo['name'];

// Helper functions
export const getTypesByCategory = (category: EventCategory): string[] => {
  return EVENT_TYPES
    .filter(type => type.categories.includes(category))
    .map(type => type.name);
};

export const getCategoriesByType = (typeName: string): string[] => {
  const type = EVENT_TYPES.find(t => t.name === typeName);
  return type ? type.categories : [];
};

// Map to help with migration from old type system
export const OLD_TYPE_TO_CATEGORY_MAP: Record<string, EventCategory> = {
  'party': 'Party',
  'art': 'Art & Exhibitions',
  'sport': 'Sport & Outdoor',
  'activism': 'Activism',
  'live_show': 'Live Show & Music',
  'food': 'Food & Drink',
  'social': 'Social Meetups',
  'market': 'Markets & Pop-Ups',
  'workshop': 'Skills & Learning',
  'family': 'Family',
  'spiritual': 'Spiritual & Wellness',
  'movie': 'Movie & Theatre'
};
